import { render, staticRenderFns } from "./TaxAgent.vue?vue&type=template&id=2e8e1f03&scoped=true"
import script from "./TaxAgent.vue?vue&type=script&lang=js"
export * from "./TaxAgent.vue?vue&type=script&lang=js"
import style0 from "./TaxAgent.vue?vue&type=style&index=0&id=2e8e1f03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8e1f03",
  null
  
)

export default component.exports